import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'antd';
import V2Form from '@/common/components/Form/V2Form';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import { getTemplateLists } from '@/common/api/expandStore/chancepoint';
import { useMethods } from '@lhb/hook';

/**
 * 选择模版弹框
 * @Description 拓店任务-开店计划-详情-创建机会点
 */
const SelectTemplateModal: React.FC<{
  visible,
  chancepointAlias,
  setVisible,
  setFormDrawerData,
}> = ({
  visible,
  chancepointAlias,
  setVisible,
  setFormDrawerData,
}) => {

  /** 真正控制弹窗显示 */
  const [curVisible, setCurVisible] = useState(false);

  const [form] = Form.useForm();
  const [options, setOptions] = useState<any>([]);

  const loadOptions = async () => {
    const result: any = await getTemplateLists();
    if (result && result.length) {
      setOptions(result.map((item) => ({ label: item.templateName, value: item.id })));
      methods.init();
    }
  };

  useEffect(() => {
    if (visible) {
      loadOptions();
    } else {
      setCurVisible(false);
    }
  }, [visible]);

  const onCancel = () => {
    setVisible(false);
  };

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
      setFormDrawerData({
        ...values,
        open: true,
      });
      onCancel();
    });
  };

  const methods = useMethods({

    init() {
      if (!Array.isArray(options)) {
        return;
      }
      // 如果只有一条数据，直接选中，否则展示弹窗
      if (options.length === 1) {
        methods.handleAutoSelectSingleItem();
      } else if (options.length > 1) {
        setCurVisible(true);
      }
    },

    /** 自动选择单条数据 */
    handleAutoSelectSingleItem() {
      if (Array.isArray(options) && options.length === 1) {
        setFormDrawerData({ templateId: options[0].value, open: true, });
        onCancel();
      }
    },

  });

  return (
    <Modal title={`选择${chancepointAlias}模板`} open={curVisible} width={336} onOk={onSubmit} onCancel={onCancel}>
      <V2Form form={form}>
        <V2FormSelect
          label='选择模板'
          name='templateId'
          placeholder='请选择模板'
          rules={[{ required: true, message: '请选择模板' }]}
          options={options}
        />
      </V2Form>
    </Modal>
  );
};

export default SelectTemplateModal;
